import React from "react";
import { StatusChip } from "../../../../../../core/ui";

const STATUS_CONFIG = {
  submitted: { label: "Submitted", variant: "submit" },
  underReview: { label: "Under Review", variant: "review" },
  approved: { label: "KYC Approved", variant: "approved" },
  notApproved: { label: "Not Approved", variant: "notApproved" },
};

const StatusBadge = ({ statusKey }) => {
  const config = STATUS_CONFIG[statusKey] || STATUS_CONFIG.submitted;
  return <StatusChip variant={config.variant} label={config.label} />;
};

export default StatusBadge;
